import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enUI from '@linktivity/link-ui/lang/en';
import jaUI from '@linktivity/link-ui/lang/ja';
import koUI from '@linktivity/link-ui/lang/ko';
import zhUI from '@linktivity/link-ui/lang/zh';
import ztUI from '@linktivity/link-ui/lang/zt';
import enText from '@link/share/i18n/lang/en';
import jaText from '@link/share/i18n/lang/ja';
import koText from '@link/share/i18n/lang/ko';
import zhText from '@link/share/i18n/lang/zh';
import ztText from '@link/share/i18n/lang/zt';
import enLanguage from '@link/share/i18n/language/en';
import jaLanguage from '@link/share/i18n/language/ja';
import koLanguage from '@link/share/i18n/language/ko';
import zhLanguage from '@link/share/i18n/language/zh';
import ztLanguage from '@link/share/i18n/language/zt';
import enAdminText from './lang/en';
import jaAdminText from './lang/ja';
import koAdminText from './lang/ko';
import zhAdminText from './lang/zh';
import ztAdminText from './lang/zt';

export const DEFAULT_LOCALE = 'ja';
export const LOCALE_LIST = ['en', 'ja', 'ko', 'zh', 'zt'];

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export const resources = {
  ja: {
    translation: {
      share: jaText,
      ...jaAdminText,
      ...jaUI,
      language: jaLanguage
    }
  },
  en: {
    translation: {
      share: enText,
      ...enAdminText,
      ...enUI,
      language: enLanguage
    }
  },
  ko: {
    translation: {
      share: koText,
      ...koAdminText,
      ...koUI,
      language: koLanguage
    }
  },
  zh: {
    translation: {
      share: zhText,
      ...zhAdminText,
      ...zhUI,
      language: zhLanguage
    }
  },
  zt: {
    translation: {
      share: ztText,
      ...ztAdminText,
      ...ztUI,
      language: ztLanguage
    }
  }
} as const;

void i18n.use(initReactI18next).init({
  lng: DEFAULT_LOCALE,
  returnNull: false,
  resources
});

export function setLocale(locale: string): string {
  void i18n.changeLanguage(locale);
  document.documentElement.setAttribute('lang', locale);
  localStorage.setItem('locale', locale);
  return locale;
}

function getLocaleParams() {
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get('lang') || '';
  if (LOCALE_LIST.includes(lang)) {
    return lang;
  }
}

(() => {
  const defaultLocale =
    getLocaleParams() || localStorage.getItem('locale') || DEFAULT_LOCALE;
  setLocale(defaultLocale);
})();

export default i18n;
